import axiosClient from "../axiosClient";
import { cachedRequest } from "../../utils/apiCache";

export function getAllGames(options = {}) {
  const request = () => axiosClient.get("/games/all");
  if (options.useCache === false) return request();
  return cachedRequest("games:all", request, {
    force: options.force === true,
  });
}

export function getTextualContent(params = {}) {
  const queryParams = new URLSearchParams();

  if (params.game_id) {
    queryParams.append("game_id", params.game_id);
  }

  if (params.content_type) {
    queryParams.append("content_type", params.content_type);
  }

  const queryString = queryParams.toString();

  const url = queryString
    ? `/textual-content?${queryString}`
    : "/textual-content";

  return cachedRequest(`textual-content:${queryString || "all"}`, () =>
    axiosClient.get(url),
    { persist: false },
  );
}
